export const sequence = (length: number) => Array.from(Array(length).keys());

export const alphaSequence = (n: number) => {
  const div = Math.floor(n / 26);
  const mod = n % 26;
  return sequence(div + 1)
    .map((n) => String.fromCharCode(65 + mod))
    .join('');
};
